module.exports = __webpack_public_path__ + "img/facebook-logo-32.2c14b8fe.svg";